const ContractManagementTabs = Object.freeze({
  CONTACT_INFORMATION: 0,
  DOCUMENTS: 1,
  CONTRACT_SIGNING: 2,
  CONTRACT_HISTORY: 3,
});

export default ContractManagementTabs;
